<ng-container *ngLet="breakPointObserve$ | async as screenRes">
  <div class="table-container" *ngLet="currentFilter$ | async">
    <ng-container *ngLet="catalogData$ | async">
      <div class="table-scroll" *ngLet="scrollDispatcher$ | async">
        <table *ngLet="langChange$ | async" mat-table [dataSource]="dataSource" [trackBy]="trackRow">
          <ng-container matColumnDef="catalogName">
            <th class="set-name" mat-header-cell *matHeaderCellDef>
              <span *ngIf="screenRes > 1024">{{ 'DATA.TABLE_HEADER.SETNAME' | translate }}</span>
              <span *ngIf="screenRes <= 1024 && screenRes > 830"
                >{{ 'DATA.TABLE_HEADER.SETNAME' | translate }},<span class="lowercase-text"> {{ 'DATA.TABLE_HEADER.CATEGORY' | translate }}</span
                >,<span class="lowercase-text"> {{ 'DATA.TABLE_HEADER.RELEVANCE' | translate }}</span
                >,<span class="lowercase-text"> {{ 'DATA.TABLE_HEADER.NOTES' | translate }}</span
                >,<span class="lowercase-text"> {{ 'DATA.TABLE_HEADER.NUMBER_VIEW' | translate }}</span
                >,<span class="lowercase-text"> {{ 'DATA.TABLE_HEADER.DOWNLOADS' | translate }}</span></span
              >
            </th>
            <td mat-cell class="set-name-cell text-left text" *matCellDef="let element">
              <a class="dataset-link" [href]="element.link">
                <div class="link-content">
                  <div (longPress)="mobileTap(element)" class="title-container">
                    <span class="mb4 h4" #catalogName [toolTipWidth]="catalogName.offsetWidth" [customToolTip]="element.catalogName">{{
                      element.catalogName
                    }}</span>

                    <div *ngIf="screenRes <= 1366" class="catalog-category mt2">
                      <!--  <svg class="svg20 primary-color mr4" [icon]="icons.Health" *ngIf="screenRes > 830" />-->

                      <span-category (click)="setCategoryFilter($event, element)" class="link-5 category-name" [matTooltip]="element.categoryName">{{
                        element.categoryName
                      }}</span-category>

                      <div class="category-name-br"></div>
                      <ng-container *ngIf="screenRes <= 1024">
                        <ng-container *ngIf="screenRes <= 830">
                          <div class="small-rating" *ngIf="!element.archive">
                            <svg class="inactive-color mr4 svg18" [icon]="icons.StarRate18" />
                            <span class="caption-4 inactive-color mr4">{{ element.rating }}</span>
                            <span class="caption-4 inactive-color">({{ element.numberVotes }})</span>
                          </div>
                        </ng-container>
                        <ng-container *ngIf="screenRes <= 1024">
                          <ng-container *ngTemplateOutlet="catalogStats; context: { element: element }"></ng-container>
                          <time [attr.datetime]="element.relevance" class="caption-3 dark-gray-color">{{ element.relevance }}</time>
                          <ng-container *ngTemplateOutlet="mapAndArchive; context: { element: element }"></ng-container>
                        </ng-container>

                        <ng-container *ngIf="screenRes <= 830">
                          <svg *ngIf="element.notificationFavoriteIcon" class="svg18 inactive-color" [icon]="element.notificationFavoriteIcon"></svg>
                        </ng-container>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </a>
            </td>
          </ng-container>

          <ng-container matColumnDef="notificationFavoriteIcon">
            <th class="icon" mat-header-cell *matHeaderCellDef>
              <span></span>
            </th>
            <td mat-cell class="icon-text" *matCellDef="let element">
              <a class="dataset-link" [href]="'' + element.link">
                <div class="link-content">
                  <svg *ngIf="element.notificationFavoriteIcon" class="svg24 inactive-color" [icon]="element.notificationFavoriteIcon"></svg>
                </div>
              </a>
            </td>
          </ng-container>

          <ng-container matColumnDef="categoryName" *ngIf="screenRes > 1366">
            <th class="category" mat-header-cell *matHeaderCellDef>
              <span>{{ 'DATA.TABLE_HEADER.CATEGORY' | translate }}</span>
            </th>
            <td mat-cell class="category-text" *matCellDef="let element">
              <a class="dataset-link" [href]="element.link">
                <div class="link-content">
                  <div class="category-container" *ngIf="screenRes > 830">
                    <div class="svg32" [innerHTML]="element.imageCode ?? '' | safeHTML"></div>
                    <span-category
                      (click)="setCategoryFilter($event, element)"
                      class="category-name"
                      [matTooltip]="'OTHER.FILTER_BY_CATEGORY' | translate"
                      >{{ element.categoryName }}</span-category
                    >
                  </div>
                </div>
              </a>
            </td>
          </ng-container>

          <ng-container matColumnDef="rating">
            <th class="rating" mat-header-cell *matHeaderCellDef>
              <span *ngIf="screenRes > 1024">{{ 'DATA.TABLE_HEADER.RATING' | translate }}</span>
            </th>
            <td mat-cell class="text text-right" *matCellDef="let element">
              <a class="dataset-link" [href]="element.link">
                <div class="link-content">
                  <app-rating
                    *ngIf="!element.archive; else noneValue"
                    [showNew]="false"
                    [apprecatedCount]="element.numberVotes"
                    [rating]="element.rating"
                  ></app-rating>
                </div>
              </a>
            </td>
          </ng-container>

          <ng-container matColumnDef="numberView">
            <th class="views" mat-header-cell *matHeaderCellDef>{{ 'DATA.TABLE_HEADER.NUMBER_VIEW' | translate }}</th>
            <td mat-cell class="text-normal text-right" *matCellDef="let element">
              <a class="dataset-link" [href]="element.link">
                <div class="link-content">
                  <span *ngIf="!element.archive; else noneValue" [matTooltip]="element.numberView">
                    {{ element.numberView }}
                  </span>
                </div>
              </a>
            </td>
          </ng-container>

          <ng-container matColumnDef="numberDownloads">
            <th class="downloads" mat-header-cell *matHeaderCellDef>{{ 'DATA.TABLE_HEADER.DOWNLOADS' | translate }}</th>
            <td mat-cell class="text-normal text-right" *matCellDef="let element">
              <a class="dataset-link" [href]="element.link">
                <div class="link-content">
                  <span *ngIf="!element.archive; else noneValue" [matTooltip]="element.numberDownloads">
                    {{ element.numberDownloads }}
                  </span>
                </div>
              </a>
            </td>
          </ng-container>

          <ng-container matColumnDef="relevance">
            <th class="relevance" mat-header-cell *matHeaderCellDef>{{ 'DATA.TABLE_HEADER.RELEVANCE' | translate }}</th>
            <td mat-cell class="text-normal text-left text-date" *matCellDef="let element">
              <a class="dataset-link" [href]="element.link">
                <div class="link-content">
                  <span [matTooltip]="element.relevance">
                    {{ element.relevance }}
                  </span>
                </div>
              </a>
            </td>
          </ng-container>

          <ng-container matColumnDef="notes">
            <th class="notes" mat-header-cell *matHeaderCellDef>{{ 'DATA.TABLE_HEADER.NOTES' | translate }}</th>
            <td mat-cell class="text-normal notes" *matCellDef="let element">
              <a class="dataset-link" [href]="element.link">
                <div class="link-content">
                  <ng-container *ngTemplateOutlet="mapAndArchive; context: { element: element }"></ng-container>
                </div>
              </a>
            </td>
          </ng-container>

          <ng-container matColumnDef="export">
            <th class="export" mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
              <a class="dataset-link" [href]="element.link">
                <div class="link-content">
                  <app-download-button [catalogId]="element.id" [catalog]="element" [isDynamic]="element.isDynamic"></app-download-button>
                </div>
              </a>
            </td>
          </ng-container>

          <ng-container matColumnDef="favorites">
            <th class="favorites" mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
              <a class="dataset-link" [href]="element.link">
                <div class="link-content">
                  <app-more-vert-menu
                    (openMenu)="openTableMenu($event)"
                    class="more_vert"
                    [menuItems]="menuItems"
                    [element]="element"
                  ></app-more-vert-menu>
                </div>
              </a>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>

          <tr
            class="table-row"
            [ngClass]="{ 'archive-catalog': row.archive }"
            (click)="selectCatalog($event, row)"
            mat-row
            *matRowDef="let row; columns: displayedColumns"
          ></tr>

          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell not-found" colspan="9999" *ngLet="!(loadingData$ | async) as loadingData">
              <app-error-page-message
                *ngIf="(isFatalError$ | async) && !firstOpen && loadingData; else notFoundMessage"
                [icon]="icons.NotAvailable"
                header="APP_ERROR_MESSAGE.DATA_LIST_UNAVAILABLE"
                message="APP_ERROR_MESSAGE.PLEASE_TRY_AGAIN_LATER"
              >
                <div class="btn-group">
                  <a class="btn-primary medium td-n mr12" href="/opendata">{{ 'APP_ERROR_MESSAGE.CHECK_AGAIN' | translate }}</a>
                  <a class="btn-secondary medium td-n" href="/">{{ 'OTHER.TO_HOME' | translate }}</a>
                </div>
              </app-error-page-message>

              <ng-template #notFoundMessage>
                <app-error-page-message
                  *ngIf="!firstOpen && loadingData"
                  [icon]="icons.NotFound"
                  header="APP_ERROR_MESSAGE.RESPONSE_NOT_FOUND"
                  message="APP_ERROR_MESSAGE.TRY_CHANGING_SEARCH_TERMS"
                >
                  <button class="btn-secondary medium td-n" (click)="ResetFilter()">{{ 'OTHER.RESET_ALL' | translate }}</button>
                </app-error-page-message>
              </ng-template>
            </td>
          </tr>
        </table>
        <ng-container *ngIf="firstOpen || (loadingData$ | async)">
          <div class="loader-container">
            <ng-container *ngTemplateOutlet="loading"></ng-container>
          </div>
        </ng-container>

        <ng-container *ngIf="loadingExtraData && !(loadingData$ | async)">
          <div class="extra-fetch">
            <ng-container *ngTemplateOutlet="loading"></ng-container>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </div>

  <ng-template #loading>
    <app-loader></app-loader>
  </ng-template>

  <ng-template #mapAndArchive let-element="element">
    <div class="svg-note" *ngIf="element.isDynamic">
      <svg [icon]="icons.Dynamic" class="inactive-color mr4 svg18" />
      <span class="caption-4 inactive-color">{{ 'DATA.TABLE_FILTER.DYNAMIC' | translate }}</span>
    </div>
    <div class="svg-note" *ngIf="element.archive">
      <svg [icon]="icons.Archive18" class="inactive-color mr4 svg18" />
      <span class="caption-4 inactive-color">{{ 'OTHER.ARCHIVE' | translate }}</span>
    </div>
    <div class="svg-note" *ngIf="element.hasGeo && isRuLocale">
      <svg [icon]="icons.Location18" class="inactive-color mr4 svg18" />
      <span class="caption-4 inactive-color">{{ 'OTHER.GOT_A_MAP' | translate }}</span>
    </div>
  </ng-template>

  <ng-template #catalogStats let-element="element">
    <div class="catalog-stats">
      <div class="catalog-stats-item mr12" *ngIf="!element.archive">
        <svg class="inactive-color mr4 svg18" [icon]="icons.Viewed18" />
        <span class="caption-4 inactive-color">{{ element.numberView | formatDigits }}</span>
      </div>
      <div class="catalog-stats-item" *ngIf="!element.archive">
        <svg class="inactive-color mr4 svg18" [icon]="icons.Downloaded18" />
        <span class="caption-4 inactive-color">{{ element.numberDownloads | formatDigits }}</span>
      </div>
    </div>
  </ng-template>
</ng-container>
<app-download-button #downloadButtonComponent hidden></app-download-button>

<ng-template #noneValue>
  <span class="body-1">—</span>
</ng-template>
